import { StateService } from "@uirouter/angularjs";
import { IOnInit, IPromise } from "angular";
import { IFieldArray } from "AngularFormly";
import { FormViewController } from "../../../../../../../records/forms/formView/controller";

import { RecordFileTemplateOptions } from "../../../../../../../records/forms/formly/types";
import {
  FormViewService,
  vsName as FormViewServiceName,
} from "../../../../../../../records/forms/formView/service";
import fieldHelpers, {
  headerField,
} from "../../../../../../../ui-formly/fieldHelpers";
import { MachineGateway } from "../../../../../models/machine";

export class MachineDetailConfigurationsWarehouseController implements IOnInit {
  static $inject = [FormViewServiceName, "$state"];

  readonly formFields: IFieldArray;
  model: any;

  /* start bindings */
  readonly machine!: MachineGateway;
  /* end binding */

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService
  ) {
    const fileTemplateOptions: RecordFileTemplateOptions = {
      allowMultiple: true,
      label: "Files",
    };

    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleDateField({
            key: "Date",
            name: "Date",
            label: "Project Date",
            required: true,
          }),
          fieldHelpers.simpleStringField({
            key: "ProjectNumber",
            name: "ProjectNumber",
            label: "Project Number",
            required: true,
          }),
          fieldHelpers.simpleStringField({
            key: "WarehouseLocation",
            name: "WarehouseLocation",
            label: "Location",
            required: true,
          }),
        ],
        4
      ),
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: fileTemplateOptions,
      },
      fieldHelpers.headerField({ headerText: "Notes", key: "NotesHeader" }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
    ];
  }

  $onInit(): void {
    const currentConfiguration = this.machine.Configs?.find(
      (c) => c.CurrentConfiguration
    );
    this.model = {
      MachineId: this.machine.Id,
      Files: currentConfiguration?.Files?.map((f) => {
        return { Name: f.Name, ContentType: f.ContentType, Url: f.Url };
      }),
    };
  }

  async submit(formViewController: FormViewController): Promise<void> {
    const machineId = this.machine.Id;
    await this.formViewService.submitForm({
      url: `/api/machines/${machineId}/warehouse`,
      formObject: this.model,
      formViewController,
      method: "post",
    });

    await this.$state.go("^", undefined, { reload: true });
  }

  async cancel(): Promise<void> {
    await this.$state.go("^");
  }
}
